import { Trans, t } from '@lingui/macro'
import { Alert, AlertTitle, Box, Grid, Icon, IconButton } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Tooltip from '@mui/material/Tooltip'
import { DialogTitleWithIconClose } from 'app/views/common-components/DialogTitleWithIconClose'

import { i18n } from '@lingui/core'
import { ArrowBackIosNewOutlined, StartOutlined } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import { getDocumentsByEntities } from 'app/services/sfAuth/sfData/sfFiles'
import {
  getFormPages
} from 'app/services/sfAuth/sfData/sfForms'
import {
  deletePrequalification,
  getPrequalifications
} from 'app/services/sfAuth/sfData/sfPrequalification'
import { useOrganizationValidityCheck } from 'app/services/sfAuth/sfHooks/useOrganizationValidityCheck'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import CustomDataTable from 'app/views/common-components/CustomDataTable'
import { PortalTabHeader } from 'app/views/common/PortalTabHeader'
import { IncompleteOrganizationDetails } from 'app/views/common/alerts/IncompleteOrganizationDetails'
import { NoOrganizationAccessBanner } from 'app/views/common/alerts/NoOrganizationAccessBanner'
import { NotConnectedToOrgBanner } from 'app/views/common/alerts/NotConnectedToOrgBanner'
import { FUNDING_PATHS } from 'app/views/funding/FundingRoutes'
import moment from 'moment'
import momentTZ from 'moment-timezone'
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import ReactToPrint from 'react-to-print'
import { myI18n } from 'translation/I18nConnectedProvider'
import { parseSFApiValueToTranslationId } from 'translation/translationUtils'
import { muiDateCompare } from 'utils'
import Loading from '../../../../egret/components/EgretLoadable/Loading'
import {
  dateFormat,
  defaultDocTitle
} from '../../../appSettings'
import {
  deleteOpportunity,
  getOpportunities,
  getOpportunityToStepper,
  opportunitiesStagesInOrder
} from '../../../services/sfAuth/sfData/sfOpportunity'
import Form from '../../forms/Form'
import { constructFormAddressString } from '../../forms/common/Common'
import { OpportunityView } from '../../opportunity/OpportunityView'
import { HEADER } from '../../opportunity/opportunityViewComponents'
import { muiTextLabels } from '../../utilities/muiDataTablesTranslations'
import { granteeReportConfiguration } from '../grantee-reports/GranteeReport'
import { ApplicationActions } from './ApplicationActions'
import { extractFormsConfig, getApplicationRolePermissions, mapApplicationsForDataTable, mapOpportunitiesToStepper, mapPrequalificationsForDataTable } from './ApplicationUtils'
import './ApplicationsList.scss'
import { OrganisationToPrint } from './old-application/PrintView'

export const RemoveApplicationDialog = ({ appToDelete, handleClose, onRemoveItem }) => {
  return (
    <Dialog
      open={Boolean(appToDelete)}
      maxWidth='xs'
      fullWidth
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitleWithIconClose
        label={<Trans>APP_DELETE_QUESTION</Trans>}
        handleClose={handleClose}
      />
      <DialogContent sx={{ paddingLeft: '48px', paddingRight: '48px' }}>
        <DialogContentText style={{ lineHeight: '20px' }}>
          <Trans>APP_DELETE_WARNING</Trans>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          '& > :not(style) ~ :not(style)': { marginLeft: '0px' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          paddingLeft: '48px',
          paddingRight: '48px',
          paddingBottom: '20px'
        }}
      >
        <Button
          variant='contained'
          color='primary'
          onClick={() =>
            onRemoveItem(appToDelete.id, appToDelete.isPrequalification)}
          fullWidth
        >
          <Trans>APP_DELETE_CONFIRMATION</Trans>
        </Button>
        <Button
          variant='outlined'
          color='primary'
          onClick={handleClose}
          fullWidth
        >
          <Trans>CANCEL</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const printStyles = (theme) => {
  return {
    root: {
      margin: theme.spacing(2),
      padding: theme.spacing(2)
      // width: 800
    },
    CellCentered: {
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    },
    button: {
      margin: theme.spacing(1)
    },
    gridObjectives: {
      flexGrow: 1
    },
    dataList: {
      padding: 15,
      marginBottom: 15,
      marginLeft: 20,
      marginRight: 20,
      flexGrow: [[1], '!important']
    },
    dataContainer: {
      padding: 15,
      width: '100%'
    },
    paperContainerStretch: {
      width: '100%',
      padding: 15
    },
    gridContainerStretch: {
      width: '100%',
      paddingLeft: 20,
      paddingRight: 20,
      marginBottom: 15
    },
    gridContainerStretchNoBreak: {
      width: '100%',
      paddingLeft: 20,
      paddingRight: 20,
      marginBottom: 15
    },
    contactGridItem: {
      minHeight: [['90px'], '!important']
    },
    '@media print': {
      fill: {
        width: [['100%'], '!important'],
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191'
      },
      titleCard: {
        padding: '5px',
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        display: [['inline-block'], '!important'],
        justifyContent: [['center'], '!important'],
        marginLeft: [[25], '!important'],
        marginRight: [[15], '!important'],
        height: [['auto'], '!important'],
        width: [['750px'], '!important']
      },
      titleCardStretch: {
        padding: '5px',
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        display: [['inline-block'], '!important'],
        justifyContent: [['center'], '!important'],
        // marginLeft: [[25], '!important'],
        // marginRight: [[15], '!important'],
        height: [['auto'], '!important'],
        width: [['100%'], '!important']
      },
      titleGrid: {
        margin: [[0], '!important'],
        height: [['auto'], '!important'],
        width: [['750px'], '!important']
        // alignItems: [['center'], '!important'],
        // justify: [['flex-start'], '!important'],
        // flexDirection: [['row'], '!important'],
        // display: [['flex'], '!important']
      },
      nameGrid: {
        width: [['300px'], '!important']
      },
      gridObjectives: {
        paddingLeft: 20,
        paddingRight: 20,
        flexGrow: 1
      },
      programManagerCard: {
        padding: [[10], '!important'],
        // marginBottom: [[40], '!important'],
        // paddinTop: [[20], '!important'],
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        display: [['inline-block'], '!important'],
        height: [['150px'], '!important'],
        width: [['300px'], '!important']
      },
      imageLogo: {
        display: [['inline'], '!important']
      },
      gridContainer: {
        display: [['flex'], '!important'],
        width: [['100%'], '!important'],
        justifyContent: [['space-evenly'], '!important'],
        alignItems: [['center'], '!important']
      },
      gridContainerStretch: {
        paddingLeft: 0,
        paddingRight: 0,
        display: [['flex'], '!important'],
        width: [['100%'], '!important'],
        marginBottom: 15,
        justifyContent: [['center'], '!important']
      },
      gridContainerStretchNoBreak: {
        paddingLeft: 0,
        paddingRight: 0,
        display: [['flex'], '!important'],
        width: [['100%'], '!important'],
        marginBottom: 15,
        justifyContent: [['center'], '!important'],
        breakInside: [['auto'], '!important'],
        pageBreakInside: [['auto'], '!important']
      },
      gridChild: {
        display: [['block'], '!important'],
        alignSelf: [['center'], '!important'],
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        margin: 'auto'
      },
      otherGrantsGrid: {
        borderRadius: 3,
        margin: 0,
        padding: 0,
        display: [['block'], '!important'],
        alignSelf: [['center'], '!important'],
        border: '2px solid',
        borderColor: '#919191',
        height: [['300px'], '!imortant'],
        width: [['368px'], '!important']
      },
      contactGridItem: {
        minHeight: [['95px'], '!important'],
        // width: [['350px'], '!important'],
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191'
      },
      gridChildHalfWidth: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        // flexGrow: 1,
        // width: '100%'
        width: [['575px'], '!important']
      },
      gridChildTable1: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        margin: 'auto',
        minHeight: [['65px'], '!important'],
        width: [['600px'], '!important']
      },
      gridChildTable2: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        margin: 'auto',
        minHeight: [['65px'], '!important'],
        width: [['150px'], '!important']
      },
      gridChildTable3: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        margin: 'auto',
        minHeight: [['65px'], '!important'],
        width: [['350px'], '!important']
      },
      gridChildTable4: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        margin: 'auto',
        minHeight: [['65px'], '!important'],
        width: [['950px'], '!important']
      },
      gridChildTable5: {
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        minHeight: [['65px'], '!important'],
        width: [['180px'], '!important']
      },
      paperContainer: {
        borderRadius: 3,
        paddingLeft: 15,
        paddingRight: 15,
        border: '2px solid',
        borderColor: '#919191'
      },
      description: {
        padding: 15,
        margin: 0,
        breakInside: [['auto'], '!important'],
        pageBreakInside: [['auto'], '!important'],
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        width: [['1150px'], '!important']
      },
      paperContainerStretch: {
        padding: 15,
        margin: 0,
        // margin: 0,
        // marginLeft: 20,
        // marginRight: 20,
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        width: [['1150px'], '!important']
      },
      dataList: {
        // padding: 15,
        // marginLeft: 20,
        // marginRight: 20,
        borderRadius: 3,
        border: '2px solid',
        borderColor: '#919191',
        breakInside: [['auto'], '!important'],
        pageBreakInside: [['auto'], '!important'],
        // flexGrow: 1,
        width: [['760px'], '!important']
      },
      dataContainer: {
        padding: 15,
        marginLeft: 20,
        marginRight: 20,
        marginBottom: 20,
        borderRadius: 3,
        flexGrow: 1,
        breakInside: [['auto'], '!important'],
        pageBreakInside: [['auto'], '!important'],
        border: [['2px solid'], '!important'],
        borderColor: [['#919191'], '!important']
        // width: [['1150px'], '!important']
      },
      mainTitle: {
        fontSize: [[24], '!important'],
        marginLeft: [[15], '!important'],
        padding: [[10], '!important']
      },
      subtitle: {
        fontSize: 12,
        color: '#919191'
      },
      hideInPrint: {
        display: [['none'], '!important'],
        visibility: [['hidden', '!important']]
      }
    }
  }
}

const useStyles = makeStyles((theme) => printStyles(theme))

export const OldFundsPrintViewDialog = ({
  opportunityToPrint,
  handleClose
}) => {
  const printRef = useRef()
  const classes = useStyles()
  const config = granteeReportConfiguration({
    classes,
    applicationList: true
  })
  config.fields.splice(
    5,
    0,
    ...OrganisationToPrint({
      classes
    }),
    {
      type: HEADER,
      style: { fontSize: 24 },
      text: (item) => (
        <span className={classes.mainTitle}>
          <Trans>Application Details</Trans>
        </span>
      )
    }
  )
  return (
    <Dialog open maxWidth='md' fullWidth scroll='paper'>
      <DialogTitle>
        <Grid container direction='row' justifyContent='space-between'>
          <ReactToPrint
            onAfterPrint={() => (document.title = defaultDocTitle)}
            onBeforePrint={() =>
              (document.title = opportunityToPrint.info.projectName)}
            trigger={() => (
              <Tooltip title={<Trans>Print</Trans>}>
                <span>
                  <IconButton
                    disabled={!opportunityToPrint.readyToPrint}
                    aria-label={<Trans>Print</Trans>}
                    className=''
                    size='large'
                  >
                    <Icon>print</Icon>
                  </IconButton>
                </span>
              </Tooltip>
            )}
            content={() => printRef.current}
          />
          <IconButton onClick={handleClose} size='large'>
            <Icon>close</Icon>
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        {!opportunityToPrint.readyToPrint && (
          <div style={{ height: 500 }}>
            <Loading />
          </div>
        )}
        {opportunityToPrint.readyToPrint && (
          <div ref={printRef}>
            <OpportunityView
              opportunity={opportunityToPrint}
              committeeType='External Review Accept'
              configuration={config}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

export const shouldShowReminderBanner = (data, recordType, cutoffDate) => {
  return (
    data
      .filter((item) => !item.isPrequalificaiton)
      .some((item) => {
        return (
          (item.stageName === 'In Progress' ||
            item.stageName === 'More info required') &&
          item.recordType === recordType
        )
      }) &&
    momentTZ
      .tz(moment.utc(), momentTZ.tz.guess())
      .isBefore(momentTZ.tz(cutoffDate, 'Pacific/Pitcairn'))
  )
}

export const ReminderBanner = ({ title, rows }) => {
  return (
    <Alert severity='warning' style={{ marginTop: 10 }}>
      <AlertTitle>
        <Trans id={title} />
      </AlertTitle>
      {rows.map((item, index) => {
        return (
          <div key={index} style={item.style}>
            <Trans id={item.id} />
          </div>
        )
      })}
    </Alert>
  )
}

const ApplicationsList = () => {
  const [loading, setLoading] = React.useState(true)
  const [data, setData] = React.useState(null)
  const [applicationToPrint, setApplicationToPrint] = React.useState(null)
  const [appToDelete, setAppToDelete] = React.useState(null)
  const [appIdsToDelete, setAppIdsToDelete] = React.useState([])
  const [opportunitiesWithContract, setOpportunitiesWithContract] = useState(
    []
  )
  const [formsConfig, setFormsConfig] = React.useState(null)
  // const [nearEndFunds, setNearEndFunds] = React.useState([])
  const configurations = useSelector((state) => state.configuration)
  const language = useSelector((state) => state?.user?.language || 'en')
  const fundingStreams = useSelector((state) => state.fundingStreams.streams)
  const organization = useSelector((state) => state.organization)
  const user = useSelector((state) => state.user)
  const classes = useStyles()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const rolePermissions = getApplicationRolePermissions(user)
  const history = useHistory()
  const { orgDetailsInvalid } = useOrganizationValidityCheck()

  useEffect(() => {
    setLoading(true)
    fetchData()
  }, [organization])

  const fetchData = () => {
    return Promise.all([
      organization.id
        ? getOpportunities({
          permissions: {
            TEAM_MEMBERS: true
          },
          searchParams: {
            AccountId: organization.id
          }
        })
        : Promise.resolve([]),
      getFormPages(),
      getPrequalifications({
        searchParams: {
          Organization_Legal_Name__c: organization.id
        }
      })
    ])
      .then(([list, forms, prequalifications]) => {
        console.log('get applications', list, prequalifications)
        console.log('got form templates', forms)

        const { formsConfig } = extractFormsConfig(forms, configurations)
        setFormsConfig(formsConfig)

        list = mapOpportunitiesToStepper(list, {})

        return getDocumentsByEntities(list.map((opp) => opp.info.id)).then(
          (files) => {
            const applicationsWithContract = []
            files.forEach((file) => {
              if (
                !applicationsWithContract.includes(file.LinkedEntityId) &&
                file.ContentVersion.TagCsv === 'unsigned_contract'
              ) {
                applicationsWithContract.push(file.LinkedEntityId)
              }
            })
            setOpportunitiesWithContract(applicationsWithContract)
            const dataToSet = [
              ...mapPrequalificationsForDataTable({
                fundingStreams,
                language,
                prequalifications
              }),
              ...mapApplicationsForDataTable({
                applications: list,
                formsConfig,
                fundingStreams,
                language,
                opportunitiesWithContract
              })
            ]
            setData(dataToSet)
            setLoading(false)
            enqueueSnackbar(<Trans>Loaded</Trans>, {
              variant: 'info'
            })
          }
        )
      })
      .catch((reject) => console.error(reject))
  }

  const handleClose = () => {
    setAppToDelete(null)
  }

  const onRemoveItem = (id, isPrequalification) => {
    const deletingSnackbarKey = enqueueSnackbar(<Trans>Deleting</Trans>, {
      variant: 'info'
    })
    setAppIdsToDelete((prev) => [...prev, id])
    setAppToDelete(null)

    const deleteFunction = isPrequalification
      ? deletePrequalification
      : deleteOpportunity

    deleteFunction(id)
      .then((result) => {
        if (!result.success) {
          enqueueSnackbar(<Trans>Error while Deleting</Trans>, {
            variant: 'error'
          })
        } else {
          closeSnackbar(deletingSnackbarKey)
          setData((prevData) => prevData.filter((item) => item.id !== id))
          enqueueSnackbar(<Trans>Deleted</Trans>, {
            variant: 'success'
          })
        }
      })
      .catch((error) => {
        console.error('Error while deleting:', error)
        enqueueSnackbar(<Trans>Error while Deleting</Trans>, {
          variant: 'error'
        })
      })
      .then(() => {
        setAppIdsToDelete((prev) => prev.filter((appId) => appId !== id))
      })
  }

  if (loading) {
    return <Loading />
  }

  const config = granteeReportConfiguration({
    classes,
    applicationList: true
  })
  config.fields.splice(
    5,
    0,
    ...OrganisationToPrint({
      classes
    }),
    {
      type: HEADER,
      style: { fontSize: 24 },
      text: (item) => (
        <span className={classes.mainTitle}>
          <Trans>Application Details</Trans>
        </span>
      )
    }
  )

  const insufficientRole = Boolean(
    !rolePermissions.manager // && !rolePermissions.contributor
  )

  return (
    <div>
      {(orgDetailsInvalid && !insufficientRole) && <IncompleteOrganizationDetails />}
      {(!organization.id) && <NotConnectedToOrgBanner />}
      <NoOrganizationAccessBanner />

      <div className='portal-tab-container'>
        <PortalTabHeader
          header={<Trans>
            MY_APPLICATIONS_HEADER
                  </Trans>}
          description={
            <Trans>
              MY_APPLICATIONS_INFO
            </Trans>
      }
          actionButton={
            <Button
              variant='contained'
              disabled={!organization.id || insufficientRole || orgDetailsInvalid}
              onClick={e => {
                history.push('/grants/apply')
              }}
            >
              <Trans>
                START_NEW_APPLICATION
              </Trans>
              <ButtonIcon IconClass={StartOutlined} />
            </Button>
      }
        />

        {applicationToPrint &&
        (applicationToPrint.formPrintId
          ? (
            <Form
              inDialog={Boolean(
                applicationToPrint && applicationToPrint.formPrintId
              )}
              onDialogClose={(e) => {
                setApplicationToPrint(null)
              }}
              forceDisabled
              disableTitle
              formId={applicationToPrint.formPrintId}
              defaultFormType='pdf'
              fetchString={constructFormAddressString({
                ids: {
                  User: user.userId,
                  Account: organization.id,
                  Opportunity: applicationToPrint.opportunityId,
                  Funding_Stream__c: applicationToPrint.fundingStream
                },
                objectsConnected: formsConfig[applicationToPrint.formPrintId]
              })}
            />
            )
          : (
            <OldFundsPrintViewDialog
              opportunityToPrint={applicationToPrint}
              handleClose={(e) => {
                setApplicationToPrint(null)
              }}
            />
            ))}

        <Box sx={{ mb: '24px', mt: '36px' }}>
          <Button
            variant='outlined' onClick={e => {
              history.push(FUNDING_PATHS.APPLY)
            }}
          >
            <ButtonIcon left IconClass={ArrowBackIosNewOutlined} />
            <Trans>
              BACK_TO_OVERVIEW
            </Trans>
          </Button>
        </Box>

        <CustomDataTable
          data={data}
          filteredColumns={[
            { key: 'fund' },
            {
              key: 'stageName',
              values: opportunitiesStagesInOrder.map(stage => ({
                key: stage,
                label: i18n._(`${parseSFApiValueToTranslationId(stage)}`)
              }))
            }
          ]}
          options={{
            textLabels: muiTextLabels(myI18n),
            filter: false,
            filterType: 'checkbox',
            selectableRows: 'none',
            print: false,
            download: false,
            viewColumns: false,
            setRowProps: (row, dataIndex, rowIndex) => {
              return {
                style: row[5] && { backgroundColor: '#F2F2F2' }
              }
            },
            sortOrder: {
              direction: 'desc',
              name: 'lastModifiedDate'
            }
          }}
          columns={[
            {
              name: 'name',
              label: myI18n._(t`Name`),
              options: {
                filter: false,
                customBodyRender: (value, { rowData }) => {
                  const isPrequalificaiton = rowData[5]
                  return (
                    <>
                      {isPrequalificaiton && (
                        <span
                          style={{
                            position: 'relative',
                            left: 8,
                            top: -11,
                            paddingRight: 8,
                            paddingLeft: 8,
                            paddingTop: 2,
                            paddingBottom: 2,
                            borderColor: '#6F6F6F',
                            color: '#6F6F6F',
                            border: '1px solid'
                          }}
                        >
                          <Trans>PREQUALIFICATION</Trans>
                        </span>
                      )}
                      <div>{value}</div>
                    </>
                  )
                }
              }
            },
            {
              name: 'fund',
              label: myI18n._(t`Fund`),
              options: {
                filter: true
              }
            },
            {
              name: 'stageName',
              label: myI18n._(t`Stage`),
              options: {
                filter: true,
                sortCompare:
                      (order) =>
                        ({ data: stage1 }, { data: stage2 }) => {
                          const ret =
                          opportunitiesStagesInOrder.indexOf(stage1) -
                          opportunitiesStagesInOrder.indexOf(stage2)
                          return order === 'asc' ? ret : ret * -1
                        },
                customBodyRender: (value) => myI18n._(value)
              }
            },
            {
              name: 'lastModifiedDate',
              sortCompare: muiDateCompare('lastModifiedDate'),
              label: myI18n._(t`Modification`),
              options: {
                filter: false,
                customBodyRender: (value, { rowData }) => {
                  const userData = rowData[7]
                  let displayValue = value ? moment.utc(value).format(dateFormat) : ''
                  if (userData) {
                    displayValue += ' | ' + userData
                  }
                  return <div>{displayValue}</div>
                }
              }
            },

            // {
            //   name: 'createdDate',
            //   sortCompare: muiDateCompare('createdDate'),
            //   label: myI18n._(t`Created date`),
            //   options: {
            //     filter: false,
            //     customHeadLabelRender: (props) => {
            //       return <Trans>Created date</Trans>
            //     },
            //     customBodyRender: (value) => {
            //       return <div>{moment.utc(value).format(dateFormat)}</div>
            //     }
            //   }
            // },
            // {
            //   name: 'pm',
            //   label: myI18n._(t`Program Manager`),
            //   options: {
            //     filter: false,
            //     sort: false,
            //     customHeadLabelRender: (props) => {
            //       return <Trans>Program Manager</Trans>
            //     },
            //     customBodyRender: (value) => {
            //       if (!value) {
            //         return <div />
            //       }
            //       return (
            //         <div>
            //           <div>{value.pmName}</div>
            //           <div>{value.pmMail}</div>
            //           <div>{value.pmPhone}</div>
            //         </div>
            //       )
            //     }
            //   }
            // },
            {
              name: 'actions',
              label: myI18n._(t`Actions`),
              options: {
                sort: false,
                filter: false,
                customHeadLabelRender: (props) => '',
                customBodyRender: (value, tableMeta, updateValue) => {
                  return (
                    <ApplicationActions
                      {...value}
                      handleShowPrint={({
                        useOldForm,
                        id,
                        fundingStream,
                        appToPrint,
                        printForm
                      }) => {
                        if (useOldForm) {
                          setApplicationToPrint(appToPrint)
                          getOpportunityToStepper(id).then((app) =>
                            setApplicationToPrint({
                              ...app,
                              readyToPrint: true
                            })
                          )
                        } else {
                          setApplicationToPrint({
                            opportunityId: id,
                            formPrintId: printForm,
                            fundingStream
                          })
                        }
                      }}
                      handleDelete={(app) => {
                        setAppToDelete(app)
                      }}
                      rolePermissions={rolePermissions}
                      disableDeleteButton={appIdsToDelete.includes(
                        value.id
                      )}
                    />
                  )
                }
              }
            },
            {
              name: 'isPrequalification',
              label: myI18n._(t`APPLICATIONS_LIST_APPLICATION_TYPE_LABEL`),
              options: {
                sort: false,
                filter: true,
                print: false,
                filterOptions: {
                  names: [
                    myI18n._(t`APPLICATIONS_LIST_OPPORTUNITIES_LABEL`),
                    myI18n._(t`APPLICATIONS_LIST_PREQUALIFICATIONS_LABEL`)
                  ],
                  logic: (isPrequalification, filterVal) => {
                    const opportunitiesLabel = myI18n._(
                      t`APPLICATIONS_LIST_OPPORTUNITIES_LABEL`
                    )
                    const prequalificationsLabel = myI18n._(
                      t`APPLICATIONS_LIST_PREQUALIFICATIONS_LABEL`
                    )

                    if (
                      filterVal.includes(opportunitiesLabel) &&
                          !isPrequalification
                    ) {
                      return false
                    }
                    if (
                      filterVal.includes(prequalificationsLabel) &&
                          isPrequalification
                    ) {
                      return false
                    }
                    return true
                  }
                },
                searchable: false,
                display: 'excluded'
              }
            },
            {
              name: 'id',
              options: {
                sort: false,
                filter: false,
                print: false,
                searchable: false,
                display: 'excluded'
              }
            },
            {
              name: 'lastModifiedUserData',
              options: {
                sort: false,
                filter: false,
                print: false,
                searchable: true,
                display: 'excluded'
              }
            }
          ]}
        />

        <RemoveApplicationDialog
          appToDelete={appToDelete}
          handleClose={handleClose}
          onRemoveItem={onRemoveItem}
        />
      </div>
    </div>
  )
}

export default ApplicationsList
